import { render, staticRenderFns } from "./ConfirmPurchaseModal.vue?vue&type=template&id=78974fb0"
import script from "./ConfirmPurchaseModal.vue?vue&type=script&lang=js"
export * from "./ConfirmPurchaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports